import { Grid, Typography } from "@mui/material";
import { useEffect } from "react";
import {
    Control,
    FieldErrors,
    UseFormRegister,
    UseFormReset,
    UseFormSetValue,
} from "react-hook-form";

import WSTextField from "../../../Components/TextBox/WSTextBox";
import { callAPI, IsSmallScreen, Method } from "../../../commonFunctions/CommonFunctions";
import WSHiddenField from "../../../Components/HiddenField/WSHiddenField";
interface ReasonProps {
    control: Control<any>;
    register: UseFormRegister<any>;
    id: any;
    reset: UseFormReset<any>;
    urlId?: string;
    setValue: UseFormSetValue<any>;
}

const ReasonComp: React.FC<ReasonProps> = ({
    control, register, id, reset, setValue, urlId
}) => {
    useEffect(() => {
        reset();

    }, [id, reset]);
    useEffect(() => {
        if (urlId) {
            setValue('id', urlId)
        }
    }, [urlId])
    return (
        <Grid >
            {<Grid style={{ paddingLeft: 5, paddingRight: 20, position: 'relative', margin: 0, marginTop: '3rem' }} container spacing={2}>
                <Grid item xs={12}>
                    <WSTextField
                        control={control}
                        id="reason"
                        {...register("reason")}
                        rules={{ required: true }}
                        name="reason"
                        label="Reason *"

                    />

                </Grid>
                <WSHiddenField control={control} defaultValue={urlId} name="id" setValue={setValue} />

            </Grid>}
        </Grid>
    );
};
export default ReasonComp;
